<template>
    <filters-wrapper :has-active-filters="hasActiveFilters" @submit="submit" @reset="reset">
        <v-form class="loyalty-points-filters">
            <v-col cols="12" md="8" class="pa-0">
                <v-row dense>
                    <v-col cols="12" md="3" sm="6">
                        <v-select
                            v-model="filters.rangeType"
                            :items="rangeType"
                            :label="$t('date_time')"
                            clearable
                            density="compact"
                            variant="outlined"
                            color="primary"
                            data-cy="data-range-type"
                        />
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                        <daterange
                            :start-date-label="$t('date_from')"
                            :end-date-label="$t('date_to')"
                            :dense="true"
                            :single-line="false"
                            :hide-details="false"
                            :min-start-date="null"
                            same-date
                            :_start-date="filters.dateFrom"
                            :_end-date="filters.dateTo"
                            data-cy="date-range"
                            @change-start-date="filters.dateFrom = $event"
                            @change-end-date="filters.dateTo = $event"
                        />
                    </v-col>
                    <v-col cols="12" md="3" sm="6">
                        <v-select
                            v-model="filters.transactionStatus"
                            :items="transactionStatus"
                            :label="$t('transaction_status')"
                            clearable
                            density="compact"
                            variant="outlined"
                            color="primary"
                            data-cy="transaction-status"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-form>
    </filters-wrapper>
</template>

<script lang="ts">
    import {Component, Emit, Prop, VModel, Vue} from 'vue-facing-decorator'
    import Daterange from '@/components/search/forms/Daterange.vue'
    import {DataRange, type SelectOptionType} from '~/utils/types/types'
    import {TransactionStatus} from '~/utils/types/account/clients/types'

    @Component({
        components: {Daterange},
    })
    export class LoyaltyPointsFilters extends Vue {
        @VModel() filters
        @Prop({required: true, type: Boolean}) hasActiveFilters: boolean
        @Emit()
        submit() {}
        @Emit()
        reset() {}

        get transactionStatus(): SelectOptionType[] {
            const transactionStatus: TransactionStatus[] = [TransactionStatus.Pending, TransactionStatus.Completed]
            return transactionStatus.map(value => ({value, title: this.$t(`transaction_statuses.${value}`)}))
        }

        get rangeType(): SelectOptionType[] {
            const stages: DataRange[] = [DataRange.AccrualOfBonusPoints]
            return stages.map(value => ({value, title: this.$t(`date_types.${value}`)}))
        }
    }

    export default LoyaltyPointsFilters
</script>
